import { useEffect } from 'react';
import { checkAppVersion } from '../utils/versionChecker';
import { toast } from 'react-toastify';

const APP_VERSION = process.env.REACT_APP_VERSION;

export function useVersionChecker(interval = 120000) {
  useEffect(() => {
    const check = async () => {
      const result = await checkAppVersion(APP_VERSION);
      if (result.updateAvailable) {
             window.location.reload(true);

      }
    };

    const timer = setInterval(check, interval);
    check(); // initial check

    return () => clearInterval(timer);
  }, []);
}
